import { render, staticRenderFns } from "./voiceRec.vue?vue&type=template&id=08b6bed7&scoped=true&lang=html"
import script from "./voiceRec.vue?vue&type=script&lang=js"
export * from "./voiceRec.vue?vue&type=script&lang=js"
import style0 from "./voiceRec.vue?vue&type=style&index=0&id=08b6bed7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b6bed7",
  null
  
)

export default component.exports